import React, { useState } from 'react';
import { RichLink } from '@naf-simba/sections-rich-link';
import { Star } from '@styled-icons/material-outlined/Star';
import { Button } from '@naf-simba/elements-buttons';
import { RelatedArticleType } from '../../../../types/articleType';
import { useDocumentUrlWithNode } from '../../hooks/Documents/useDocumentUrl';
import FallbackImage from '../../../assets/images/fallback_image.png';
import { useCloudinary } from '../../hooks/Cloudinary/useCloudinary';
import * as S from './TestCollection.styles';

const TestCollectionCard = ({ testItem }: { testItem: RelatedArticleType }) => {
  const { image, name, ingress, selectedscore, maxscore } = testItem;
  const { getProcessedImage } = useCloudinary();
  const mainImage =
    getProcessedImage(image?.publicId || image?.public_id, {
      height: 120,
      width: 160,
      focusMethod: image?.focus,
      quality: 'auto:eco',
    })?.toURL() ?? FallbackImage;
  const itemUrl = useDocumentUrlWithNode(testItem) || '';

  if (!itemUrl) {
    return null;
  }

  return (
    <RichLink
      to={itemUrl}
      title={name}
      media={{
        src: mainImage || '',
        alt: image?.altText || '',
      }}
      description={
        <S.IconWrapper>
          {!!selectedscore && (
            <S.IconSet>
              <Star size={24} />
              <span>
                <b>{selectedscore} poeng</b> {!!maxscore && `av ${maxscore}`}
              </span>
            </S.IconSet>
          )}
          {ingress && !selectedscore && <div>{ingress}</div>}
        </S.IconWrapper>
      }
    />
  );
};

const Item = (testItem: RelatedArticleType) => {
  const { name } = testItem;
  return (
    <S.RelatedListItem key={`testCollectionItem-${name}`}>
      <TestCollectionCard testItem={testItem} />
    </S.RelatedListItem>
  );
};

export const TestCollection = ({ testCollection }: { testCollection: RelatedArticleType[] }) => {
  const [isOpen, setIsOpen] = useState(false);

  const visibleTests = testCollection.slice(0, 3);
  const restOfTests = testCollection.slice(3);

  return (
    <S.RelatedList>
      {visibleTests && visibleTests.map(Item)}
      {testCollection.length > 3 && (
        <>
          <S.ShowMoreWrapper
            $isHidden={!isOpen}
            $height={restOfTests.length * 240} // 240 is the height of the card ++, if size changes, this needs to be changed
          >
            {restOfTests.map(Item)}
          </S.ShowMoreWrapper>
          <Button color="secondary" onClick={() => setIsOpen(!isOpen)}>
            {!isOpen ? 'Se alle +' : 'Skjul tester'}
          </Button>
        </>
      )}
    </S.RelatedList>
  );
};
